export default __webpack_public_path__ + "justhatched-screens_small.966bb1e8.png";